import React, {
  useEffect,
  useState,
  useRef,
} from 'react';
import moment from 'moment';
import { useStores } from '../../hooks/use-stores';

const Counter = ({
  currentCount,
  delay = 0,
  restart = false,
  start = false,
  onChange = () => {},
}) => {
  const [count, setCount] = useState(currentCount || delay || 0);
  const [formatted, setFormatted] = useState('00:00:00');
  const { asyncStore } = useStores();

  const timeoutRef = useRef(null);
  const onChangeRef = useRef(onChange);
  const prevStartRef = useRef(start);

  // Update ref if onChange changes
  useEffect(() => {
    onChangeRef.current = onChange;
  }, [onChange]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        asyncStore.clearTimeout(timeoutRef.current);
      }
    };
  }, [asyncStore]);

  // Only reset when start transitions from true to false
  useEffect(() => {
    if (prevStartRef.current && !start) {
      setCount(0);
      setFormatted(moment().startOf('day').format('HH:mm:ss'));
      if (timeoutRef.current) {
        asyncStore.clearTimeout(timeoutRef.current);
      }
    }
    prevStartRef.current = start;
  }, [start, asyncStore]);

  // Main ticking logic
  useEffect(() => {
    if (!start) {
      setCount(0);
      setFormatted(moment().startOf('day').format('HH:mm:ss'));
      if (timeoutRef.current) {
        asyncStore.clearTimeout(timeoutRef.current);
      }
      return;
    }

    if (restart) {
      setCount(0 - delay);
    }

    const tick = () => {
      setCount((prev) => prev + 1);
      timeoutRef.current = asyncStore.setTimeout(tick, 1000);
    };

    timeoutRef.current = asyncStore.setTimeout(tick, 1000);

    return () => {
      if (timeoutRef.current) {
        asyncStore.clearTimeout(timeoutRef.current);
      }
    };
  }, [start, restart, delay, asyncStore]);

  // Update formatted time and trigger onChange
  useEffect(() => {
    const _count = currentCount !== 0 ? count : 0;
    const date = moment().startOf('day').add(Math.abs(_count), 'seconds');
    setFormatted(date.format('HH:mm:ss'));

    // Call the latest onChange safely
    onChangeRef.current({ seconds: count });
  }, [count, currentCount]);

  const sign = count < 0 ? 'minus' : count > 0 ? 'plus' : 'zero';

  return (
    <span className={`seconds-counter-${sign}`}>
      <i className="fa fa-clock-o hidden-xs" /> {formatted}
    </span>
  );
};

export default Counter;

export const formatSeconds = (seconds) => {
  const abs = Math.abs(seconds);
  const hrs = Math.floor(abs / 3600);
  const mins = Math.floor((abs % 3600) / 60);
  const secs = abs % 60;

  const pad = (num) => String(num).padStart(2, '0');

  return `${pad(hrs)}:${pad(mins)}:${pad(secs)}`;
};
